import React from 'react';
import { Link } from 'react-router-dom';
import { isAdmin, isManager } from '../service/authService';

export default function AdminNavigation(props) {
   const checkAdmin = isAdmin();
   const checkReport = isAdmin || isManager();
   return (
      <div>
         <ul className='nav flex-column nav-pills' id='v-pills-tab' role='tablist' aria-orientation='vertical'>
            {checkAdmin && (
               <li className='nav-item'>
                  <Link className='nav-link' to={'/UserList'}>
                     User List
                  </Link>
               </li>
            )}
            {checkReport && (
               <li className='nav-item'>
                  <Link className='nav-link' to={'/VendorList'}>
                     Vendor Accounts
                  </Link>
               </li>
            )}
            {checkAdmin && (
               <li className='nav-item'>
                  <Link className='nav-link' to={'/FloatList'}>
                     Float Accounts
                  </Link>
               </li>
            )}
            {checkReport && (
               <li className='nav-item'>
                  <Link className='nav-link' to={'/EndDayHistory'}>
                     End of Day History
                  </Link>
               </li>
            )}
            {checkAdmin && (
               <li className='nav-item'>
                  <Link className='nav-link' to={'/TokenReprint'}>
                     Token Reprint
                  </Link>
               </li>
            )}
            <li className='nav-item'>
               <Link className='nav-link' to={'/SalesReport'}>
                  Sales Report
               </Link>
            </li>
            {checkAdmin && (
               <li className='nav-item'>
                  <Link className='nav-link' to={'/TokenReprint'}>
                     View System Health
                  </Link>
               </li>
            )}
         </ul>
      </div>
   );
}
